import Carousel from "~/components/carousel"
import { StarCard } from "~/components/cards"
import { dailyShuffle } from "~/utils/data"
import type { EmblaOptionsType } from "embla-carousel-react"

const options: EmblaOptionsType = {
  loop: false,
  duration: 20,
  slidesToScroll: 1,
  inViewThreshold: 0.5,
  breakpoints: {
    "(min-width: 640px)": {
      slidesToScroll: 3,
    },
    "(min-width: 1024px)": {
      slidesToScroll: 4,
    },
  },
}

export const StarsCarousel = ({ stars, loggedIn, isPaymentVerified, className }: any) => {
  return (
    <Carousel options={options} className={className}>
      {dailyShuffle(stars ?? []).map((star: any, index: number) => (
        <StarCard
          star={star}
          loggedIn={loggedIn}
          isPaymentVerified={isPaymentVerified}
          key={index}
          className="md:hover:scale-[1.15] md:hover:z-20 transition delay-200 duration-300 flex-[0_0_100%] sm:flex-[0_0_33.3%] lg:flex-[0_0_25%]"
        />
      ))}
    </Carousel>
  )
}
